import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { courseDetails, receiptBasicDetails, studentDetails } from './constant'
import PaymentDetails from './PaymentDetails'

const ReceiptDetail= ({
    receiptDetail={paymentModeBreakupDTOList:[]},
    totalPaidAmount,
    contextValue,
    setTotalPaidAmount})=>{
    const getFormatCol=(label='',value='',flag=false,index)=>{
        return <>
            <Col md={4} className='mt-24'>
            <div>
                <div className='large-semi-bold label-color'>
                    {(value&&value!==" ")?Array.isArray(value)?value.join(', '):value:label=='PSERP ID'?<span style={{color:'#D29822'}}>In progress</span>:'N/A'}
                    {Array.isArray(value)}
                </div>
                <div className='regular-small'>
                    {label}
                </div>
            </div>
            </Col>
            {flag&&index==4?<Col md={4} className='mt-24'></Col>:''}
            
        </>
    }

    return(
        <Card >
            <CardBody>


                <diV className='dark-text label-color'>Receipt Details</diV>
                <Row>
                    {receiptBasicDetails.map((item)=>{
                        return getFormatCol(item?.label,receiptDetail[item?.key])
                            
                    })}
                </Row >

                <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2"}}></div>
                
                <div className='tiny-semi-bold mt-24' >
                    STUDENT DETAILS
                </div>
                <Row>
                    {studentDetails.map((item,index)=>{
                        return getFormatCol(item?.label,receiptDetail[item?.key],true,index)
                            
                    })}
                </Row >

                <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2"}}></div>

                <div className='tiny-semi-bold mt-24'>
                    COURSE DETAILS
                </div>

                <Row>
                    {courseDetails.map((item)=>{
                        return getFormatCol(item?.label,receiptDetail[item?.key])
                            
                    })}
                </Row >
                <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2"}}></div>
                <div className='tiny-semi-bold mt-24'>
                    PAYMENT DETAILS
                </div>
                <div className='tiny-semi-bold mt-24'>
                    <PaymentDetails 
                    rowList={receiptDetail?.paymentModeBreakupDTOList?receiptDetail?.paymentModeBreakupDTOList.map((item,index)=>({...item,id:index})):[]}
                    totalPaidAmount={totalPaidAmount}
                    setTotalPaidAmount={setTotalPaidAmount}
                    contextValue={contextValue}
                    />
                </div>
            </CardBody>
        </Card>

    )
}
export default ReceiptDetail